import { Brakets } from 'Assets/icons/Brakets'
import { PapperplaneIcon } from 'Assets/icons/PaperplaneIcon'
import { TagManagerIcon } from 'Assets/icons/TagManagerIcon'
import { WordPressIcon } from 'Assets/icons/WordPressIcon'
import i18n from 'Lib/i18n'
import React from 'react'

export type TagMethods =
  | 'diy'
  | 'gtmGallery'
  | 'gtmManual'
  | 'wordpress'
  | 'googleIntegration'
  | 'emailDev'
export interface RadioMethodsSelection {
  label: string
  value: TagMethods
  icon: React.ReactNode
}

export const METHODS_SELECTION_OPTIONS = () => {
  return [
    {
      label: i18n.t('get_tag_modal.methods.google_tag_manager_manual', {
        ns: 'domainManagement',
      }),
      value: 'gtmManual',
      icon: <TagManagerIcon />,
    },
    {
      label: i18n.t('get_tag_modal.methods.myself', { ns: 'domainManagement' }),
      value: 'diy',
      icon: <Brakets />,
    },
    // TODO: uncomment as soon as Google approves our gallery template
    // {
    //   label: i18n.t('get_tag_modal.methods.google_tag_manager_gallery', { ns: 'domainManagement' }),
    //   value: 'gtmGallery',
    //   icon: <TagManagerIcon />,
    // },

    {
      label: i18n.t('get_tag_modal.methods.wordpress', { ns: 'domainManagement' }),
      value: 'wordpress',
      icon: <WordPressIcon />,
    },
    {
      label: i18n.t('get_tag_modal.methods.email_developer', { ns: 'domainManagement' }),
      value: 'emailDev',
      icon: <PapperplaneIcon />,
    },
  ]
}
